import { Injectable } from '@angular/core';

@Injectable()
export class BrowserDetectionService {

  constructor() { }

  isInAppBrowser(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /FBAN|FBAV|Instagram|Twitter|Snapchat|Pinterest|WebView|Line/i.test(userAgent);
  }
}
